module.exports = __webpack_public_path__ + "img/control_de_calidad_9-16_1620.f859163d.webp";